/** Shared client-side backoff when the API returns 429. */
let rateLimitedUntil = 0;

export const isRateLimited = (): boolean => Date.now() < rateLimitedUntil;

export const markRateLimited = (retryAfterSeconds = 60): void => {
  rateLimitedUntil = Date.now() + retryAfterSeconds * 1000;
};

export const clearRateLimit = (): void => {
  rateLimitedUntil = 0;
};
